import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { SelectField } from "@/lib/crm";
import { Panel, SectionLabel } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const opts = (items, fmt) => (items || []).map((x) => ({ key: x.id, label: fmt(x) }));

const DdtDialog = ({ d, open, onOpenChange, onDone }) => {
  const [f, setF] = useState({});
  const [o, setO] = useState({ orders: [], assets: [], docs: [] });
  useEffect(() => {
    if (!open) return;
    setF({ ...d.ddt });
    const p = { params: { company_id: d.company_id } };
    Promise.allSettled([api.get("/orders", p), api.get("/assets", { params: { company_id: d.company_id, limit: 200 } }), api.get("/documents", p)]).then(([a, b, c]) => setO({
      orders: a.value ? opts(a.value.data.items, (x) => `${x.number} · ${x.title || ""}`) : [],
      assets: b.value ? opts(b.value.data.items, (x) => `${x.code || ""} ${x.name}`) : [],
      docs: c.value ? opts(c.value.data.items.filter((x) => x.id !== d.id), (x) => `${x.number} · ${x.title}`) : [] }));
  }, [open, d]);
  const save = async () => {
    try { await api.put(`/documents/${d.id}/ddt`, { ...f, order_id: f.order_id || null, asset_id: f.asset_id || null, related_document_id: f.related_document_id || null }); toast.success("DDT aggiornato"); onOpenChange(false); onDone(); }
    catch (e) { toast.error(errorMessage(e)); }
  };
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}><DialogContent className="max-w-lg" data-testid="ddt-dialog">
      <DialogHeader><DialogTitle>Dati DDT</DialogTitle></DialogHeader>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5"><Label className="text-xs">Numero *</Label><Input value={f.number || ""} maxLength={40} onChange={(e) => set("number")(e.target.value)} data-testid="ddt-number" /></div>
        <div className="space-y-1.5"><Label className="text-xs">Data *</Label><Input type="date" value={f.date || ""} onChange={(e) => set("date")(e.target.value)} data-testid="ddt-date" /></div>
        <SelectField className="col-span-2" label="Ordine" value={f.order_id} onChange={set("order_id")} options={o.orders} allowNone="Nessuno" testId="ddt-order" />
        <SelectField className="col-span-2" label="Asset" value={f.asset_id} onChange={set("asset_id")} options={o.assets} allowNone="Nessuno" testId="ddt-asset" />
        <SelectField className="col-span-2" label="Documento correlato" value={f.related_document_id} onChange={set("related_document_id")} options={o.docs} allowNone="Nessuno" testId="ddt-related" />
        <div className="col-span-2 space-y-1.5"><Label className="text-xs">Note</Label><Input value={f.notes || ""} maxLength={1000} onChange={(e) => set("notes")(e.target.value)} data-testid="ddt-notes" /></div>
      </div>
      <DialogFooter><Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button><Button disabled={!(f.number || "").trim() || !f.date} onClick={save} data-testid="ddt-save">Salva</Button></DialogFooter>
    </DialogContent></Dialog>
  );
};

const Row = ({ l, v, t }) => <div className="flex justify-between gap-3 py-1.5 text-sm"><span className="text-slate-500">{l}</span><span className="text-right text-ink" data-testid={t}>{v || "—"}</span></div>;

export const DdtPanel = ({ d, onDone }) => {
  const [open, setOpen] = useState(false);
  const l = d.ddt_labels || {};
  return (
    <Panel className="p-5" data-testid="document-ddt"><div className="flex items-center justify-between"><SectionLabel>DDT</SectionLabel>
      {d.can.update && !d.is_archived && <Button size="sm" variant="ghost" onClick={() => setOpen(true)} data-testid="document-ddt-edit">Modifica</Button>}</div>
      <Row l="Numero" v={d.ddt.number} t="ddt-view-number" /><Row l="Data" v={fmtDate(d.ddt.date)} t="ddt-view-date" /><Row l="Cliente" v={d.company_name} t="ddt-view-company" />
      <Row l="Ordine" v={l.order_id} t="ddt-view-order" /><Row l="Asset" v={l.asset_id} t="ddt-view-asset" /><Row l="Correlato" v={l.related_document_id} t="ddt-view-related" />
      {d.ddt.notes && <p className="mt-2 text-xs text-slate-500">{d.ddt.notes}</p>}
      <DdtDialog d={d} open={open} onOpenChange={setOpen} onDone={onDone} />
    </Panel>
  );
};
